import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="relative py-12 px-4 sm:px-6 lg:px-8 overflow-hidden bg-black border-t border-zinc-900" data-id="element-158">
      <div className="max-w-7xl mx-auto" data-id="element-159">
        {/* CTA Section */}
        <div className="text-center mb-16 pb-12 border-b border-zinc-900" data-id="element-160">
          <a href="/application" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-black bg-white rounded-lg hover:bg-zinc-100 transition-all duration-200 shadow-lg hover:shadow-xl" data-id="element-161">
            Get Started Now
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-162">
          {/* Column 1: Company */}
          <div data-id="element-163">
            <h3 className="text-1xl font-bold mb-6 text-white tracking-tight" data-id="element-164">
              VANTAGE CAPITAL GROUP
            </h3>
            <p className="text-white mb-6 text-sm leading-relaxed max-w-xs" data-id="element-165">
              Empowering businesses with flexible capital solutions.
            </p>
            <div className="flex items-center gap-2 text-sm text-zinc-500" data-id="element-166">
              <ShieldCheckIcon className="w-5 h-5 text-white" data-id="element-167" />
              <span data-id="element-168">Secure & Confidential</span>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div data-id="element-169">
            <h4 className="font-bold text-lg mb-6 text-white" data-id="element-170">Quick Links</h4>
            <ul className="space-y-3 text-zinc-400 text-sm" data-id="element-171">
              <li data-id="element-172">
                <a href="#" className="hover:text-white transition-colors" data-id="element-173">
                  Home
                </a>
              </li>
              <li data-id="element-174">
                <a href="#about" className="hover:text-white transition-colors" data-id="element-175">
                  About Us
                </a>
              </li>
              <li data-id="element-176">
                <a href="#how-it-works" className="hover:text-white transition-colors" data-id="element-177">
                  How It Works
                </a>
              </li>
              <li data-id="element-178">
                <a href="#faq" className="hover:text-white transition-colors" data-id="element-179">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Funding Types */}
          <div data-id="element-180">
            <h4 className="font-bold text-lg mb-6 text-white" data-id="element-181">
              Funding Options
            </h4>
            <ul className="space-y-3 text-zinc-400 text-sm" data-id="element-182">
              <li data-id="element-183">
                <a href="#" className="hover:text-white transition-colors" data-id="element-184">
                  SBA Loans
                </a>
              </li>
              <li data-id="element-185">
                <a href="#" className="hover:text-white transition-colors" data-id="element-186">
                  Business Lines of Credit
                </a>
              </li>
              <li data-id="element-187">
                <a href="#" className="hover:text-white transition-colors" data-id="element-188">
                  Equipment Financing
                </a>
              </li>
              <li data-id="element-189">
                <a href="#" className="hover:text-white transition-colors" data-id="element-190">
                  Working Capital
                </a>
              </li>
              <li data-id="element-191">
                <a href="#" className="hover:text-white transition-colors" data-id="element-192">
                  Merchant Cash Advance
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-900 pt-8 flex flex-col justify-center items-center text-xs text-white space-y-2" data-id="element-193">
          <p data-id="element-194">© {currentYear} Vantage Capital Group. All rights reserved.</p>
          <div className="flex space-x-8" data-id="element-195">
            <a href="#" className="hover:text-zinc-300 transition-colors" data-id="element-196">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-zinc-300 transition-colors" data-id="element-197">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}